<template>
    <span class="error--text v-messages" v-text="message" />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

function isValidationMessage(r: unknown): r is string {
    return typeof r === 'string';
}

@Component({
    name: 'ValidationErrorMessage',
})
export default class ValidationErrorMessage extends Vue {
    @Prop({ default: undefined }) readonly value: any | null | undefined;
    @Prop({ default: () => [] }) readonly rules: Array<boolean | string | ((val: any) => boolean | string)>;

    /*
     * setters, getters
     */
    get message(): string | undefined {
        const validate_results = this.rules.map(r => {
            if (typeof r === 'function') {
                return r(this.value);
            } else {
                return r;
            }
        });

        return validate_results.find(isValidationMessage);
    }
}
</script>
